// extracted by mini-css-extract-plugin
export default {"body":"StatsPage_body__c5soe"};